import React, { useState, useEffect } from "react";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { BrowserRouter as Router } from "react-router-dom";
import Navbar from "./components/Navbar/Navbar";
import AppRoutes from "./routes/Routes";
import ErrorBoundaryComponent from "./components/error/ErrorBoundaryComponent";
import themes from "./Themes/theme";
import Footer from "./components/Footer/FooterComponent";
import { Box } from "@mui/material";

const App = () => {
  const [themeMode, setThemeMode] = useState(localStorage.getItem("theme") || "dark");

  useEffect(() => {
    localStorage.setItem("theme", themeMode);
  }, [themeMode]); // Se actualiza cada vez que el tema cambia

  const toggleTheme = () => {
    setThemeMode((prevMode) => (prevMode === "dark" ? "light" : "dark"));
  };

  return (
    <ThemeProvider theme={themes[themeMode]}>
      <CssBaseline />
      <Router>
        <ErrorBoundaryComponent>
          <Navbar toggleTheme={toggleTheme} themeMode={themeMode} />
          <Box sx={{ overflowX: "hidden" }}>
            <AppRoutes />
          </Box>
          <Footer />
        </ErrorBoundaryComponent>
      </Router>
    </ThemeProvider>
  );
};

export default App;
